import React from "react"

export const TutorialIcon = ({ width = 24, height = 24, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M22 10V16M2 10L12 5L22 10L12 15L2 10Z" />
      <path d="M6 12V17C9 20 15 20 18 17V12" />
    </g>
  </svg>
)
